import { render, staticRenderFns } from "./TrackAction.vue?vue&type=template&id=b5fd2b10&scoped=true"
import script from "./TrackAction.vue?vue&type=script&lang=js"
export * from "./TrackAction.vue?vue&type=script&lang=js"
import style0 from "./TrackAction.vue?vue&type=style&index=0&id=b5fd2b10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fd2b10",
  null
  
)

export default component.exports